import { WORKOUT_KEY } from '../../../workout'
import { REDUX_DOMAIN_LIST_SECTION_DATE_KEYS } from '../../constants/key'
import { REDUX_DOMAIN_TO_SORT_KEYS } from '../../constants/should-sort'

export default function getSortKeysReduxUtil ({ domainPath, domainListPath = '' }) {
  if (REDUX_DOMAIN_LIST_SECTION_DATE_KEYS.find(key => domainListPath.includes(key))) {
    return [
      WORKOUT_KEY.PLANNED_AT,
      WORKOUT_KEY.LOGGED_AT
    ]
  }
  return REDUX_DOMAIN_TO_SORT_KEYS[domainPath] || []
}
